import AscPopover from "../../../../AscPopover/AscPopover";
import ColorPicker from "./ColorPicker/ColorPicker";
import { TextColorIcon } from "../../../../AscIcons";
import styles from "./DropdownColorPicker.module.scss";

type Props = {
  disabled?: boolean;
  color: string;
  onChange?: (color: string) => void;
};

export default function DropdownColorPicker({
  disabled = false,
  color,
  onChange,
}: Props) {
  return (
    <AscPopover
      title={<TextColorIcon />}
      titleContainerClassName={styles["title"]}
      variant="secondary"
      hideArrowIcon
      disabled={disabled}
    >
      <ColorPicker color={color} onChange={onChange} />
    </AscPopover>
  );
}
